import { render, staticRenderFns } from "./ProductPlayer.vue?vue&type=template&id=03e3307d&scoped=true&"
import script from "./ProductPlayer.vue?vue&type=script&lang=js&"
export * from "./ProductPlayer.vue?vue&type=script&lang=js&"
import style0 from "./ProductPlayer.vue?vue&type=style&index=0&id=03e3307d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e3307d",
  null
  
)

export default component.exports